var _rect;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIdentity = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Top_Secret_24",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.42 0 0 0.42 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 9)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -33)",
    d: "M 5.5 26.5 L 5.5 36.5 C 5.5 38.2 6.8 39.5 8.5 39.5 L 39.5 39.5 C 41.2 39.5 42.5 38.2 42.5 36.5 L 42.5 27",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -10.1)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -13.9)",
    d: "M 42.5 19.2 L 42.5 16.5 C 42.5 14.8 41.2 13.5 39.5 13.5 L 23.5 13.5 L 18.6 9.4 C 17.900000000000002 8.8 17 8.5 16 8.5 L 8.5 8.5 C 6.8 8.5 5.5 9.8 5.5 11.5 L 5.5 19.3",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 5.75)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "currentColor",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -0.25,
    x2: 0,
    y2: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 5.5)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -29.5)",
    d: "M 28.5 34.5 L 19.5 34.5 C 18.4 34.5 17.5 33.6 17.5 32.5 L 17.5 26.5 C 17.5 25.4 18.4 24.5 19.5 24.5 L 28.5 24.5 C 29.6 24.5 30.5 25.4 30.5 26.5 L 30.5 32.5 C 30.5 33.6 29.6 34.5 28.5 34.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -2.6)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -21.4)",
    d: "M 21 24.3 L 21 21.5 C 21 19.8 22.3 18.5 24 18.5 L 24 18.5 C 25.7 18.5 27 19.8 27 21.5 L 27 24",
    strokeLinecap: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIdentity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/identity.04308ca4.svg";
export { ForwardRef as ReactComponent };